import { render } from "./PaymentHeader.vue?vue&type=template&id=7f5aaa1d&scoped=true"
import script from "./PaymentHeader.vue?vue&type=script&lang=js"
export * from "./PaymentHeader.vue?vue&type=script&lang=js"

import "./PaymentHeader.vue?vue&type=style&index=0&id=7f5aaa1d&scoped=true&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5aaa1d"]])

export default __exports__